import { html } from 'lit';
const TelegramDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#2AABEE" d="M12 2a9.999 9.999 0 0 0-7.07 17.071A9.999 9.999 0 1 0 19.07 4.93 10 10 0 0 0 12 2"/><path fill="#fff" d="M6.527 11.894q4.374-1.905 5.83-2.511c2.78-1.156 3.356-1.356 3.732-1.363.083-.001.267.02.388.116a.43.43 0 0 1 .142.271c.012.078.03.255.015.394-.15 1.581-.801 5.418-1.132 7.19-.14.749-.416 1-.683 1.024-.581.054-1.022-.383-1.585-.752-.88-.577-1.376-.936-2.23-1.499-.988-.65-.348-1.008.215-1.593.147-.153 2.706-2.48 2.755-2.691.006-.026.012-.125-.047-.177s-.144-.034-.207-.02q-.132.03-4.218 2.788-.598.411-1.085.4c-.356-.007-1.043-.201-1.554-.367-.625-.204-1.124-.311-1.08-.657q.033-.27.744-.553"/>
  </svg>
`;
export default TelegramDuotone;
